import { getFrequencyLabel } from "library/get-frequency-label.mjs"

export function normaliseCustomScheduleAuditFrequency(data) {
    if (!Array.isArray(data)) return data

    data.forEach((entry) => {
        if (entry?.type !== "customSchedule") return
        const { payload } = entry
        if (!payload) return
        payload.original = normaliseFrequencyObject(payload.original)
        payload.tailored = normaliseFrequencyObject(payload.tailored)
    })

    return data
}

function normaliseFrequencyObject(obj) {
    if (!obj) return obj
    if (!obj.frequency) return obj
    return { ...obj, frequency: toLabel(obj.frequency) }
}

function toLabel(frequency) {
    if (!frequency) return frequency
    if (typeof frequency === "string") return frequency
    if (typeof frequency === "object") {
        if ("label" in frequency) return frequency.label
        if ("frequency" in frequency) return frequency.frequency
        if ("period" in frequency && "interval" in frequency) return getFrequencyLabel(frequency)
    }
    return frequency
}
